import { render, staticRenderFns } from "./UiBlockUser.vue?vue&type=template&id=606dc3fe&"
import script from "./UiBlockUser.vue?vue&type=script&lang=js&"
export * from "./UiBlockUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports